const mixinFun = {
  methods: {
    // 检测手机号
    checkUserPhone (phone) {
      let phoneFlag = true
      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (phone === '') { this.$message.error('请填写手机号'); phoneFlag = false }
      if (phone !== '' && !reg.test(phone)) { this.$message.error('请输入正确的手机号'); phoneFlag = false }
      return phoneFlag
    },

    //  检测是否登录
    checkIsLogin () {
      let isLogin = false
      const info = localStorage.getItem('tokenStr')
      info ? isLogin = true : isLogin = false
      return isLogin
    },

    // 获取近期日期
    getDate (dateNum) {
      const date = new Date() // 当前日期

      // 近期日期
      const recentDate = new Date(date)
      recentDate.setDate(date.getDate() + dateNum)

      // 定义月日补零
      const month = (recentDate.getMonth() + 1) >= 10 ? (recentDate.getMonth() + 1) : '0' + (recentDate.getMonth() + 1)
      const day = recentDate.getDate() >= 10 ? recentDate.getDate() : '0' + recentDate.getDate()

      // 近期时间
      const recentime = recentDate.getFullYear() + '-' + month + '-' + day
      return recentime
    },

    // 去除文本的html标签
    delHtmlTag (str) {
      const reg = /<\/?.+?\/?>/g
      const regs = /&emsp;|&gt;|&nbsp;|&lt;/g

      const newStr = str.replace(reg, '')
      return newStr.replace(regs, '')
    },

    // 根据后缀名检测文件类型
    matchFileSuffixType (fileName) {
      // 后缀获取
      var suffix = ''
      // 获取类型结果
      var result = ''
      try {
        var flieArr = fileName.split('.')
        suffix = flieArr[flieArr.length - 1]
      } catch (err) {
        suffix = ''
      }
      // fileName无后缀返回 false
      if (!suffix) {
        result = false
        return result
      }
      // 图片格式
      var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif']
      // 进行图片匹配
      result = imglist.some(function (item) {
        return item === suffix
      })
      if (result) {
        result = 'image'
        return result
      }
      // 匹配txt
      var txtlist = ['txt']
      result = txtlist.some(function (item) {
        return item === suffix
      })
      if (result) {
        result = 'txt'
        return result
      }
      // 匹配 excel
      var excelist = ['xls', 'xlsx']
      result = excelist.some(function (item) {
        return item === suffix
      })
      if (result) {
        result = 'excel'
        return result
      }
      // 匹配 word
      var wordlist = ['doc', 'docx']
      result = wordlist.some(function (item) {
        return item === suffix
      })
      if (result) {
        result = 'word'
        return result
      }
      // 匹配 pdf
      var pdflist = ['pdf']
      result = pdflist.some(function (item) {
        return item === suffix
      })
      if (result) {
        result = 'pdf'
        return result
      }
      // 匹配 ppt
      var pptlist = ['ppt']
      result = pptlist.some(function (item) {
        return item === suffix
      })
      if (result) {
        result = 'ppt'
        return result
      }
      // 匹配 视频
      var videolist = ['mp4', 'm2v', 'mkv']
      result = videolist.some(function (item) {
        return item === suffix
      })
      if (result) {
        result = 'video'
        return result
      }
      // 匹配 音频
      var radiolist = ['mp3', 'wav', 'wmv']
      result = radiolist.some(function (item) {
        return item === suffix
      })
      if (result) {
        result = 'radio'
        return result
      }
      // 其他 文件类型
      result = 'other'
      return result
    },

    // 将时间戳日期转换为年月日
    timestampToTime (timestamp) {
      var date = new Date(timestamp) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      const Y = date.getFullYear() + '-'
      const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      const D = date.getDate() >= 10 ? date.getDate() : '0' + date.getDate()
      // const h = date.getHours() + ':'
      // const m = date.getMinutes() + ':'
      // const s = date.getSeconds()

      return Y + M + D // 时分秒可以根据自己的需求加上
    }

  },
  filters: {
    // 限制字数长度
    limitWordText (title, lennum) {
      if (title && title.length > lennum) {
        return title.substr(0, lennum) + '...'
      } else {
        return title
      }
    }

  }
}

export default mixinFun
